import { render, staticRenderFns } from "./signCofig.vue?vue&type=template&id=70b57ba1&scoped=true"
import script from "./signCofig.vue?vue&type=script&lang=js"
export * from "./signCofig.vue?vue&type=script&lang=js"
import style0 from "./signCofig.vue?vue&type=style&index=0&id=70b57ba1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b57ba1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b57ba1')) {
      api.createRecord('70b57ba1', component.options)
    } else {
      api.reload('70b57ba1', component.options)
    }
    module.hot.accept("./signCofig.vue?vue&type=template&id=70b57ba1&scoped=true", function () {
      api.rerender('70b57ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/component/signCofig.vue"
export default component.exports